import React from 'react';
import classNames from 'classnames';

function SectionDescription({ children, className, ...otherProps }) {
	return (
		<p className={classNames('fs-4 c-neutral-700 lh-copy lh-copy--xs pb-2', className)} {...otherProps}>
			{children}
		</p>
	);
}

export default SectionDescription;
